import AnchorMenu from './AnchorMenu';
export default AnchorMenu;
